import { FONTSIZE, BORDER_RADIUS, FONTWEIGHT, COLORS } from "../../utils/styles"
// this comment tells babel to convert jsx to calls to a function called jsx instead of React.createElement
/** @jsx jsx */
import { css, jsx } from "@emotion/react"
const container = (width: string) =>
  css`
    width: ${width};
    font-weight: ${FONTWEIGHT.REGULAR};
    color: ${COLORS.C2C2C2C};
    background-color: ${COLORS.CF5F7FF};
    border: 1px solid ${COLORS.CE3E9FF};
    border-radius: ${BORDER_RADIUS.BORDER_RADIUS_5};
    line-height: 1.6;
    justify-content: flex-start;
  `

const regularSize = css`
  font-size: ${FONTSIZE.F14};
  padding: 12px 16px;
`

const largeSize = css`
  font-size: ${FONTSIZE.F24};
  padding: 16px 16px;
`

const icon = css`
  align-self: flex-start;
  width: 18px;
  height: 18px;
  padding: 2px 8px;
  padding-left: 0;
`

const smallSize = css`
  font-size: ${FONTSIZE.F10};
  padding: 12px 16px;
`;

export { container, icon, regularSize, largeSize, smallSize }
